// MapInitializerNogeo.tsx
import { useEffect } from "react";

type AppLocation = {
  city: string;
  country: string;
  countryCode?: string;
  coords: { lat: number; lng: number };
};

export default function MapInitializerNogeo({
  setLocation,
}: {
  setLocation: (loc: AppLocation) => void;
}) {
  useEffect(() => {
    const stored = sessionStorage.getItem("selectedLocation");
    if (!stored) return;

    try {
      const parsed = JSON.parse(stored);

      if (parsed?.city && parsed?.country) {
        setLocation({
          city: parsed.city,
          country: parsed.country,
          countryCode: parsed.countryCode,
          coords: { lat: 0, lng: 0 },
        });
      }
    } catch {
      // ignore invalid storage
    }
  }, [setLocation]);

  return null;
}